// Screen definition: Actividades
// Client-side pagination
import type { ScreenDefinition } from '@/types/screen-definition';

export const actividadScreenDef: ScreenDefinition = {
  id: 'actividades',
  title: 'Actividades',
  itemLabel: 'actividades',

  columns: [
    {
      key: '_check',
      header: '',
      type: 'custom', // Inline complete button — too interactive for standard renderer
      sortable: false,
      locked: true,
      width: 64,
    },
    {
      key: 'titulo',
      header: 'Actividad',
      type: 'custom', // Link with strikethrough + type + subtask count
      locked: true,
    },
    {
      key: 'tipo_actividad',
      header: 'Tipo',
      type: 'custom',
      sortable: false,
    },
    {
      key: 'cliente_nombre',
      header: 'Cliente',
      type: 'text',
      sortable: false,
      config: { muted: true, fallback: '-' },
    },
    {
      key: 'area',
      header: 'Área',
      type: 'badge',
      config: {
        labelMap: { TRABAJO: 'Work', ADMINISTRATIVO: 'Admin', PERSONAL: 'Personal' },
      },
    },
    {
      key: 'estado',
      header: 'Estado',
      type: 'status',
    },
    {
      key: 'prioridad',
      header: 'Prioridad',
      type: 'priority',
    },
    {
      key: 'fecha_agendada',
      header: 'Fecha',
      type: 'custom', // Two dates with icons — too specific
    },
    {
      key: 'responsable_nombre',
      header: 'Responsable',
      type: 'text',
      sortable: false,
      config: { muted: true, fallback: '-' },
    },
  ],

  defaultSort: { field: 'fecha_agendada', order: 'asc' },

  pagination: {
    mode: 'client',
    defaultPageSize: 25,
  },

  search: {
    enabled: true,
    placeholder: 'Buscar actividades...',
  },

  quickFilters: [
    {
      key: 'area',
      label: 'Área',
      options: [
        { value: 'TRABAJO', label: 'Work' },
        { value: 'ADMINISTRATIVO', label: 'Admin' },
        { value: 'PERSONAL', label: 'Personal' },
      ],
    },
  ],

  filterSections: [
    {
      key: 'clasificacion',
      title: 'Clasificación',
      filters: [
        {
          key: 'estado',
          label: 'Estado',
          type: 'multi-select',
          options: [
            { value: 'PENDIENTE', label: 'Pendiente' },
            { value: 'EN_PROCESO', label: 'En Proceso' },
            { value: 'EN_ESPERA', label: 'En Espera' },
            { value: 'EN_REVISION', label: 'En Revisión' },
            { value: 'COMPLETADA', label: 'Completada' },
            { value: 'CANCELADA', label: 'Cancelada' },
          ],
        },
        {
          key: 'prioridad',
          label: 'Prioridad',
          type: 'select',
          options: [
            { value: 'AAA', label: 'AAA - Máxima' },
            { value: 'AA', label: 'AA - Alta' },
            { value: 'A', label: 'A - Normal' },
            { value: 'B', label: 'B - Baja' },
            { value: 'C', label: 'C - Mínima' },
          ],
        },
      ],
    },
    {
      key: 'fechas',
      title: 'Fechas',
      filters: [
        { key: 'fecha', label: 'Rango de fecha', type: 'date-range' },
      ],
    },
  ],

  rowClick: { type: 'navigate', path: '/actividades/:id' },

  empty: {
    message: 'No se encontraron actividades',
    icon: 'ClipboardList',
  },
};
